export const GET_INSIGHTS_SUCCESS = "GET_INSIGHTS_SUCCESS";
